import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  dateFormat,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { useLocation } from "react-router-dom";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { Table3 } from "../../components/table/Table3";
import { IoDocument } from "react-icons/io5";

const Product = () => {
  ChangeTitle("Product");
  const location = useLocation();
  const serviceIds = location.state?.serviceIds || [];
  const [mainMenu] = useState("");
  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(5);
  const [sortField, setSortField] = useState("created");
  const [sortOrder, setSortOrder] = useState("desc");
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState([]); // All Data List
  // const [data, setData] = useState([
  //   {
  //     category: "Law",
  //     law: "VAT Law",
  //     arabicName: "",
  //     chapter: "Law",
  //     product: "",
  //     entity: "",
  //     language: "Arabic",
  //     issueDate: "Not available",
//     publishDate: "Not available",
  //     docNo: "Qm 09",
  //   },
  // ]); // All Data List

  // Products List Api call

  const viewProductsList = async (
    sortOrder,
    sortField,
    limit,
    offset,
    filter,
    search
  ) => {
    const param = {
      term: search,
      // productcategoryId: filter || "",
      taxserviceId: serviceIds,
      sort: sortOrder,
      sortBy: sortField,
      limit: limit,
      offset: offset,
    };

    var response = await postData(
      "private/product/list/filter",
      param,
      apiHeader(false),
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const totalRecords = response.data.data.totalRecord;
      setData(data);
      setTotalRecords(totalRecords);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewProductsList(sortOrder, sortField, limit, offset, mainMenu,search);
  }, [sortOrder, sortField, limit, offset, mainMenu,search]);

  // table columns
  const columns = [
    {
      class: "min-w-[100px]",
      name: <label className="st-head-tr-th-text">Sr. No.</label>,
      cell: (row, rowIndex, baseIndex) => {
        const srNo = baseIndex + rowIndex + 1;
        return srNo;
      },
      sortable: false,
      field: "_id",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Country</label>,
      cell: (row) => row.countryName,
      sortable: false,
      field: "countryName",
    },
    {
      class: "min-w-[250px]",
      name: <label className="st-head-tr-th-text">Law</label>,
      cell: (row) => row.taxserviceName && row.taxserviceName,
      sortable: false,
      field: "serviceName",
    },
    // {
    //   class: "min-w-[200px]",
    //   name: <label className="st-head-tr-th-text">Name</label>,
    //   cell: (row) => row.name,
    //   sortable: false,
    //   field: "name",
    // },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Issue Date</label>,
      cell: (row) => dateFormat(row.issueDate),
      sortable: false,
      field: "issueDate",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Published Date</label>,
      cell: (row) => dateFormat(row.publishDate),
      sortable: false,
      field: "publishDate",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Category</label>,
      cell: (row) => row.categoryName && row.categoryName,
      sortable: false,
      field: "categoryName",
    },
    {
      class: "min-w-[200px]",
      name: <label className="st-head-tr-th-text">Sub Category</label>,
      cell: (row) => row.productsubcategory,
      sortable: false,
      field: "productsubcategory",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Chapter</label>,
      cell: (row) => row.chapter,
      sortable: false,
      field: "chapter",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Product</label>,
      cell: (row) => row.product,
      sortable: false,
      field: "product",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Entity</label>,
      cell: (row) => row.entity,
      sortable: false,
      field: "entity",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">Language</label>,
      cell: (row) => row.language,
      sortable: false,
      field: "language",
    },
    {
      class: "min-w-[150px]",
      name: <label className="st-head-tr-th-text">File Link</label>,
      cell: (row) =>
        row.link && (
          <a href={row.link} target="_blank" rel="noopener noreferrer">
            <IoDocument className="table-doc-icon" />
          </a>
        ),
      sortable: false,
      field: "link",
    },
  ];

  const handleSort = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
    setOffset(0); // Reset to the first page on sort change
    viewProductsList(newSortOrder, field, limit, offset, mainMenu);
  };

  //   const partnerSettings = {
  //     slidesPerRow: 1,
  //     slidesToShow: 6,
  //     slidesToScroll: 1,
  //     infinite: false,
  //     swipeToSlide: true,
  //     arrows: true,
  //     nextArrow: (
  //       <div>
  //         <div className="relative top-[-1.5rem] left-[-4rem] xs:left-[-4.5rem] md:left-[-4rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] w-max shadow-lg main-arrow main-arrow2">
  //           <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
  //             <IoMdArrowRoundForward className="text-4xl arrow" />
  //           </div>
  //         </div>
  //       </div>
  //     ),
  //     prevArrow: (
  //       <div>
  //         <div className="relative z-[10] top-[-2.5rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] left-[-9rem] w-max shadow-lg main-arrow">
  //           <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
  //             <IoMdArrowRoundBack className="text-4xl arrow" />
  //           </div>
  //         </div>
  //       </div>
  //     ),
  //     responsive: [
  //       {
  //         breakpoint: 1440,
  //         settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 1,
  //         },
  //       },
  //       {
  //         breakpoint: 976,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 1,
  //         },
  //       },
  //       {
  //         breakpoint: 640,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //         },
  //       },
  //     ],
  //   };

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="sec-product">
            <Table3
              className="px-[3%] py-[3%] mb-5 lg:mb-8"
              columns={columns}
              data={data || []}
              totalRecords={totalRecords}
              additionalField={""}
              searchPlaceholder="Search Product"
              searchValue={search}
              setSearchValue={(e) => {
                setSearch(e.target.value);
                setOffset(0);
              }}
              isSearch={true}
              limit={limit}
              offset={offset}
              setOffset={setOffset}
              isAllowAllList={true}
              setLimit={setLimit}
              sortField={sortField}
              sortOrder={sortOrder}
              handleSort={handleSort}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
